import React, { FC, PropsWithChildren, ReactNode } from 'react'
import { Lazy, M, O, pipe, v } from '@packages/prelude'
import * as ReactDOM from 'react-dom'

export const monoid: M.Monoid<JSX.Element> = {
  concat: (x, y) => (
    <>
      {x}
      {y}
    </>
  ),
  empty: <></>
}

export function mount(elem: HTMLElement | null, factory: Lazy<JSX.Element>) {
  pipe(
    elem,
    O.fromNullable,
    O.foldMap(v.Monoid)(el => {
      ReactDOM.render(factory(), el)
    })
  )
}

export const mountTo = (factory: Lazy<JSX.Element>) => (elem: Element) => {
  ReactDOM.render(factory(), elem)
}

export function wrap(Wrapper: FC<PropsWithChildren<unknown>>): (content: ReactNode) => JSX.Element {
  return content => <Wrapper>{content}</Wrapper>
}
